export const Hamburger = () => {
  return (
    <svg fill="none" height="33" viewBox="0 0 47 33" width="47" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.4809 0H3.8619C1.72903 0 0 1.72903 0 3.8619C0 5.99478 1.72903 7.72381 3.8619 7.72381H42.4809C44.6138 7.72381 46.3429 5.99478 46.3429 3.8619C46.3429 1.72903 44.6138 0 42.4809 0Z"
        fill="currentColor"
      />
      <path
        d="M42.4809 12.3584H3.8619C1.72903 12.3584 0 14.0874 0 16.2203C0 18.3532 1.72903 20.0822 3.8619 20.0822H42.4809C44.6138 20.0822 46.3429 18.3532 46.3429 16.2203C46.3429 14.0874 44.6138 12.3584 42.4809 12.3584Z"
        fill="currentColor"
      />
      <path
        d="M42.4809 24.7158H3.8619C1.72903 24.7158 0 26.4449 0 28.5777C0 30.7106 1.72903 32.4396 3.8619 32.4396H42.4809C44.6138 32.4396 46.3429 30.7106 46.3429 28.5777C46.3429 26.4449 44.6138 24.7158 42.4809 24.7158Z"
        fill="currentColor"
      />
    </svg>
  );
};
